import { CaretLeft } from '@phosphor-icons/react';
import { initialen } from '../../../lib/immobilien/format';
import type { MieterKopfZustand } from '../../../lib/mieter/useMieterKopf';
import { MIETER_NAV, type MieterPanelKey } from '../mieterWidgets';
import { NavZeile } from './NavZeile';
import { SidebarDock } from './SidebarDock';

/** Kontext-Sidebar im Mietermodus (Handoff Mieter §5.4, Screen 10). */
export function MieterModus({ mieterId, zustand, panel, onNavigate }: {
  mieterId: string;
  zustand: MieterKopfZustand;
  /** ?panel=<key> der aktuellen URL */
  panel: string | null;
  onNavigate: (pfad: string) => void;
}) {
  const basis = `/admin/mieter/${encodeURIComponent(mieterId)}`;
  const kopf = zustand.status === 'ok' ? zustand.kopf : null;
  const anzahl = (key: MieterPanelKey): number | null => {
    if (!kopf) return null;
    if (key === 'vertraege' || key === 'dokumente' || key === 'tickets' || key === 'termine' || key === 'notizen') return kopf.anzahl[key];
    return null;
  };

  return (
    <div className="immo-side-in flex flex-col flex-1 min-h-0" style={{ gap: 12 }}>
      <button
        type="button"
        onClick={() => onNavigate('/admin/mieter')}
        className="immo-hover-flaeche flex items-center self-start cursor-pointer"
        style={{ height: 30, padding: '0 12px 0 8px', borderRadius: 15, border: 'none', gap: 5, background: 'var(--fill2)', fontSize: 12, fontWeight: 700, color: 'var(--ink)' }}
      >
        <CaretLeft weight="bold" size={12} />
        Alle Mieter
      </button>

      <button
        type="button"
        onClick={() => onNavigate(basis)}
        aria-label={kopf ? `${kopf.name} – Übersicht` : 'Mieter-Übersicht'}
        className="immo-innen flex items-center cursor-pointer text-left"
        style={{ borderRadius: 18, border: 'none', padding: 12, gap: 10, color: 'var(--ink)' }}
      >
        <span className="immo-akzent flex items-center justify-center shrink-0" style={{ width: 42, height: 42, borderRadius: '50%', fontSize: 14, fontWeight: 800 }}>
          {kopf ? initialen(kopf.name) : ''}
        </span>
        <span className="flex flex-col min-w-0" style={{ gap: 1 }}>
          {zustand.status === 'laedt' && <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Lädt …</span>}
          {zustand.status === 'fehler' && <span style={{ fontSize: 12, color: 'var(--bad)' }}>Mieter konnte nicht geladen werden.</span>}
          {zustand.status === 'fehlt' && <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Mieter nicht gefunden.</span>}
          {kopf && (
            <>
              <span className="truncate" style={{ fontSize: 14, fontWeight: 800, letterSpacing: '-0.01em' }}>{kopf.name}</span>
              <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{kopf.einheit || 'Keine Einheit'}</span>
            </>
          )}
        </span>
      </button>

      <nav aria-label="Mieternavigation" className="immo-ohne-scrollbar flex flex-col flex-1 min-h-0 overflow-auto" style={{ gap: 1, margin: '0 -4px', padding: '0 4px' }}>
        {MIETER_NAV.map(abschnitt => (
          <div key={abschnitt.abschnitt} className="flex flex-col" style={{ gap: 1 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink3)', padding: '12px 9px 4px' }}>{abschnitt.abschnitt}</span>
            {abschnitt.eintraege.map(e => {
              const n = e.key === 'uebersicht' ? null : anzahl(e.key);
              const ticketBadge = e.key === 'tickets' && n !== null && n > 0;
              return (
                <NavZeile
                  key={e.key}
                  art="objekt"
                  label={e.label}
                  icon={e.icon}
                  aktiv={e.key === 'uebersicht' ? !panel : panel === e.key}
                  anzahl={ticketBadge ? null : n}
                  rechts={ticketBadge ? (
                    <span className="immo-zahl flex items-center justify-center" style={{ minWidth: 20, height: 20, padding: '0 6px', borderRadius: 10, fontSize: 11, fontWeight: 700, background: 'var(--bad)', color: '#fff' }}>{n}</span>
                  ) : undefined}
                  onClick={() => onNavigate(e.key === 'uebersicht' ? basis : `${basis}?panel=${e.key}`)}
                />
              );
            })}
          </div>
        ))}
      </nav>

      <SidebarDock aktiv="mieter" onNavigate={onNavigate} />
    </div>
  );
}
